export interface AccountStatementState {
    accountsStatementData?: object;
    inProgress?: boolean;
    error?: any;
    notify?: boolean;
    filterData?: Array<any>;
    ccyName?: object;
    blocksByIban?: Array<any>;
    accountsData?: Array<any>;
    inProgressAccounts?: boolean;
    moreDetailData?: object;
    ibanNumber?:object;
    requisiteData?: object;
    accountLoading?: boolean;
    balanceLoading?: boolean;
    transferWidgetLoading?: boolean;
}

export enum AccountStatementActionTypes {
    GET_ACCOUNTS_STATEMENT_REQUEST = 'GET_ACCOUNTS_STATEMENT_REQUEST',
    GET_ACCOUNTS_STATEMENT_SUCCESS = 'GET_ACCOUNTS_STATEMENT_SUCCESS',
    GET_ACCOUNTS_STATEMENT_ERROR = 'GET_ACCOUNTS_STATEMENT_ERROR',
    SET_ACCOUNTS_STATEMENT_FILTER = 'SET_ACCOUNTS_STATEMENT_FILTER',
    SET_CCY_NAME = 'SET_CCY_NAME',
    GET_BLOCKED_IBAN_REQUEST = 'GET_BLOCKED_IBAN_REQUEST',
    GET_BLOCKED_IBAN_SUCCESS = 'GET_BLOCKED_IBAN_SUCCESS',
    GET_BLOCKED_IBAN_ERROR = 'GET_BLOCKED_IBAN_ERROR',
    GET_ACCOUNTS_DATA_REQUEST = 'GET_ACCOUNTS_DATA_REQUEST',
    GET_ACCOUNTS_DATA_SUCCESS = 'GET_ACCOUNTS_DATA_SUCCESS',
    GET_ACCOUNTS_DATA_ERROR = 'GET_ACCOUNTS_DATA_ERROR',
    SET_MORE_DETAIL = 'SET_MORE_DETAIL',
    SET_IBAN_NUMBER = 'SET_IBAN_NUMBER',
    GET_REQUISITE_REQUEST = 'GET_REQUISITE_REQUEST',
    GET_REQUISITE_SUCCESS = 'GET_REQUISITE_SUCCESS',
    GET_REQUISITE_ERROR = 'GET_REQUISITE_ERROR',
    SET_ACCOUNT_LOADING = 'SET_ACCOUNT_LOADING',
    SET_BALANCE_LOADING = 'SET_BALANCE_LOADING',
    SET_TRANSFER_WIDGET_LOADING = 'SET_TRANSFER_WIDGET_LOADING',
}

interface SetAccountsStatementRequestAction {
    type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_REQUEST
}

interface SetAccountsStatementSuccessAction {
    type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_SUCCESS;
    payload: any;
}

interface SetAccountsStatementErrorAction {
    type: AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_ERROR;
    error: any;
}

interface SetAccountsStatementRefreshAction {
    type: AccountStatementActionTypes.SET_ACCOUNTS_STATEMENT_FILTER;
    payload: any;
}

interface SetCCYNAMEAction {
    type: AccountStatementActionTypes.SET_CCY_NAME;
    payload: any;
}

interface GetBlockedIbanRequestAction {
    type: AccountStatementActionTypes.GET_BLOCKED_IBAN_REQUEST
}

interface GetBlockedIbanSuccessAction {
    type: AccountStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS;
    payload: any;
}

interface GetBlockedIbanErrorAction {
    type: AccountStatementActionTypes.GET_BLOCKED_IBAN_ERROR;
    error: any;
}

interface SetAccountsDataRequestAction {
    type: AccountStatementActionTypes.GET_ACCOUNTS_DATA_REQUEST
}

interface SetAccountsDataSuccessAction {
    type: AccountStatementActionTypes.GET_ACCOUNTS_DATA_SUCCESS;
    payload: any;
}

interface SetAccountsDataErrorAction {
    type: AccountStatementActionTypes.GET_ACCOUNTS_DATA_ERROR;
    error: any;
}

interface SetMoreDetailAction {
    type: AccountStatementActionTypes.SET_MORE_DETAIL;
    payload: any;
}

interface SetIbanNumberAction {
    type: AccountStatementActionTypes.SET_IBAN_NUMBER;
    payload: any;
}

interface SetRequisiteRequestAction {
    type: AccountStatementActionTypes.GET_REQUISITE_REQUEST
}

interface SetRequisiteSuccessAction {
    type: AccountStatementActionTypes.GET_REQUISITE_SUCCESS;
    payload: any;
}

interface SetRequisiteErrorAction {
    type: AccountStatementActionTypes.GET_REQUISITE_ERROR;
    error: any;
}

interface SetAccountAction {
    type: AccountStatementActionTypes.SET_ACCOUNT_LOADING;
    payload: any;
}

interface SetBalanceAction {
    type: AccountStatementActionTypes.SET_BALANCE_LOADING;
    payload: any;
}

interface SetTransferWidgetAction {
    type: AccountStatementActionTypes.SET_TRANSFER_WIDGET_LOADING;
    payload: any;
}


export type AccountStatementAction =
    SetAccountsStatementRequestAction |
    SetAccountsStatementSuccessAction |
    SetAccountsStatementErrorAction   |
    SetAccountsStatementRefreshAction |
    SetCCYNAMEAction                  |
    GetBlockedIbanRequestAction       |
    GetBlockedIbanSuccessAction       |
    GetBlockedIbanErrorAction         |
    SetAccountsDataRequestAction      |
    SetAccountsDataSuccessAction      |
    SetAccountsDataErrorAction        |
    SetMoreDetailAction               |
    SetIbanNumberAction               |
    SetRequisiteRequestAction         |
    SetRequisiteSuccessAction         |
    SetRequisiteErrorAction           |
    SetAccountAction                  |
    SetBalanceAction                  |
    SetTransferWidgetAction
